var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 41 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#24498C",
  d: "M12.503.119a1.13 1.13 0 0 0-1.006 0L2.872 4.43a1.12 1.12 0 0 0-.622 1.005v6.52c0 3.661 2.03 6.657 4.17 8.699a17 17 0 0 0 3.166 2.392c.482.278.932.498 1.324.65.369.145.757.259 1.09.259s.721-.114 1.09-.258a10 10 0 0 0 1.324-.651 17 17 0 0 0 3.166-2.393c2.14-2.041 4.17-5.037 4.17-8.698v-6.52c0-.43-.244-.816-.622-1.005z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D5CB1",
  fillRule: "evenodd",
  d: "m12 1.5 8.25 4.17v6.286c0 3.088-1.72 5.718-3.705 7.614a15.5 15.5 0 0 1-2.88 2.177c-.433.25-.815.434-1.12.554a3 3 0 0 1-.38.125 1 1 0 0 1-.165.03z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.035 8.595a1.09 1.09 0 0 1 0 1.538l-5.454 5.454c-.21.197-.488.302-.775.295h-.109a1.09 1.09 0 0 1-.796-.48l-2.182-3.273a1.092 1.092 0 1 1 1.811-1.21l1.44 2.181 4.516-4.516a1.09 1.09 0 0 1 1.55-.022z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFBE3D",
  fillRule: "evenodd",
  d: "m29 9.544 8.25 4.125v6.287c0 3.088-1.72 5.718-3.705 7.614a15.5 15.5 0 0 1-2.88 2.177c-.433.25-.815.434-1.12.554a3 3 0 0 1-.38.125q-.075.019-.122.025l-.043.005m5.58-1.802c2.14-2.041 4.17-5.037 4.17-8.698v-6.52c0-.43-.244-.816-.622-1.005L29.503 8.12a1.13 1.13 0 0 0-1.006 0l-8.625 4.312a1.12 1.12 0 0 0-.622 1.005v6.52c0 3.661 2.03 6.657 4.17 8.699a17 17 0 0 0 3.166 2.392 10 10 0 0 0 1.324.65c.369.145.757.259 1.09.259s.721-.114 1.09-.258a10 10 0 0 0 1.324-.651 17 17 0 0 0 3.166-2.393",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD76A",
  fillRule: "evenodd",
  d: "M20.75 13.625 29 9.5l8.25 4.17v6.286c0 3.088-1.72 5.718-3.705 7.614a15.5 15.5 0 0 1-2.88 2.177c-.433.25-.815.434-1.12.554a3 3 0 0 1-.38.125q-.075.019-.122.025l-.043.005V15.5l-8.25 4.125v-2.25L29 13.25v-1.5l-8.25 4.125z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#654418",
  d: "M34.035 16.595a1.09 1.09 0 0 1 0 1.538l-5.454 5.454c-.21.197-.488.302-.775.295h-.109a1.09 1.09 0 0 1-.796-.48l-2.182-3.273a1.09 1.09 0 1 1 1.811-1.21l1.44 2.181 4.516-4.516a1.09 1.09 0 0 1 1.55-.022z"
})));
export default SvgUsBadge;